<template>
  <el-form class="imperial-setting">
    <div style="text-align: center; padding-bottom: 5px">
      <b style="font-size: large">{{ $t('CargoMsg.Cargo_ImperialUnits') + $t('CargoMsg.Cargo_Switch') }}</b>
    </div>
    <div>
      <el-form-item :label="$t('CargoMsg.Cargo_BusinessType')">
        <el-select v-model="currentKey" clearable>
          <el-option v-for="item in imperialSetting" :key="item.key" :value="item.key" :label="languageFunc(item)" />
        </el-select>
      </el-form-item>
      <div v-for="item in modules" :key="item.key">
        <el-form-item label-width="100px" :label="languageFunc(item)">
          <el-radio-group v-model="from[item.key]">
            <el-radio :label="false" style="margin-right: 15px;">{{ $t('CargoMsg.Cargo_Metric') }}</el-radio>
            <el-radio :label="true" style="margin-right: 15px;">{{ $t('CargoMsg.Cargo_Imperial') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <el-col class="color-save-btn">
        <el-button type="primary" @click="handleSave">{{ $t('Tool.Save') }}</el-button>
      </el-col>
    </div>
  </el-form>
</template>

<script>
import lodash from 'lodash'
import { getUserInfo } from '@/utils/auth'
import { getPersonQueryConfig, savePersonQueryConfig } from '@/api/commonComponent'
import { getLoading } from '@/utils/utilBaseElement'
import store from '@/store'
export default {
  name: 'ImperialSetting',
  data() {
    return {
      loading: null,
      currentKey: 'ae',
      modules: [],
      from: {
        ae_1: true,
        ae_2: true,
        ae_3: true,
        ae_4: true,
        ae_5: true,
        ae_6: true
      }
    }
  },
  computed: {
    store() {
      return store
    },
    imperialSetting() {
      return lodash.cloneDeep(this.$store.state.settings.imperialSettings)
    },
    language() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    currentKey(e) {
      this.currentKeyChange(e)
    }
  },
  created() {
    this.currentKeyChange()
  },
  methods: {
    languageFunc(item) {
      return this.language ? item.name : item.englishName
    },
    currentKeyChange(e) {
      this.modules = []
      const currentKey = e || this.currentKey
      const currentOpt = this.imperialSetting.find(item => item.key === currentKey)
      if (currentOpt) {
        this.modules = Array.from(currentOpt.children)
        for (const m of this.modules) {
          this.from[m.key] = m.imperial
        }
      }
    },
    handleSave() {
      const currentOpt = this.imperialSetting.find(item => item.key === this.currentKey)
      if (currentOpt) {
        this.loading = getLoading('imperial-setting')
        this.modules = Array.from(currentOpt.children)
        for (const m of this.modules) {
          m.imperial = this.from[m.key]
        }
        const currentUserInfo = getUserInfo()
        const data = {
          bDefault: true,
          configModule: '25057',
          configName: `local_uiDoc_person_colorModule_${currentUserInfo.tenantId}_${currentUserInfo.userId}_25057`,
          configType: 3, // 固定值，表格配置
          configContent: JSON.stringify(this.imperialSetting)
        }
        this.$store.dispatch('settings/changeSetting', { key: 'imperialSettings', value: this.imperialSetting })
        savePersonQueryConfig(data).then(res => {
          this.$message.success(this.$t('Tool.SaveSucceed'))
        }).finally(() => {
          this.loading.close()
        })
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBusinessType'))
      }
    },
    reload() {
      this.loading = getLoading('imperial-setting')
      const currentUserInfo = getUserInfo()
      const data = {
        bDefault: true,
        configModule: '25057',
        configName: `local_uiDoc_person_colorModule_${currentUserInfo.tenantId}_${currentUserInfo.userId}_25057`,
        configType: 3, // 固定值，表格配置
        configBy: currentUserInfo.userId,
        tenantId: currentUserInfo.tenantId
      }
      getPersonQueryConfig(data).then(res => {
        const { data } = res
        const defaultConfig = data.find(item => item.bDefault)
        if (defaultConfig && defaultConfig.configContent) {
          const cacheConfig = store.state.settings.imperialSettings
          const remoteConfigs = JSON.parse(defaultConfig.configContent)
          console.log('settings/changeSetting', remoteConfigs)
          const configMerged = cacheConfig.reduce((result, config) => {
            const newConfig = { ...config }
            Object.keys(newConfig).forEach(key => {
              const remoteConfig = remoteConfigs.find(conf => conf.key === config.key)
              if (key !== 'key' && remoteConfig && remoteConfig[key] !== undefined) {
                newConfig[key] = remoteConfig[key]
              }
            })
            result.push(newConfig)
            return result
          }, [])
          this.$store.dispatch('settings/changeSetting', { key: 'imperialSettings', value: configMerged })
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.imperial-setting {
  padding: 10px 60px 45px 60px;
  .color-save-btn{
    padding-top: 10px;
    text-align: center;
    .el-button{
      width: 120px;
      background-color: #409EFF;
      border-color: #409EFF;
    }
  }
}
</style>
